import React from "react";
import { css } from "emotion";
import { Card, Button, Heading } from "@maxmilhas/hangar-components-atomic/public";
import { wrapper } from "./style";

const CardAction = ({
	title,
	titleIcon,
	children,
	button,
	buttonClick,
	buttonData,
	secondaryButton,
	secondaryButtonClick,
	secondaryButtonData
}) => {
	const wrapperStyle = wrapper(!!secondaryButton);

	return (
		<Card>
			<div
				className={css`
					${wrapperStyle};
				`}
			>
				<header>
					<i className={titleIcon} />
					<Heading tag="normal">{title}</Heading>
				</header>
				<div className="content">{children}</div>
				<footer>
					<Button
						onClick={buttonClick}
						style={buttonClick ? {} : { visibility: "hidden" }}
						{...(buttonData ? { "data-action": buttonData } : {})}
					>
						{button}
					</Button>
					{secondaryButton && (
						<a
							className="secondary-button"
							role="button"
							onClick={secondaryButtonClick}
							{...(secondaryButtonData ? { "data-action": secondaryButtonData } : {})}
						>
							{secondaryButton}
						</a>
					)}
				</footer>
			</div>
		</Card>
	);
};

export default CardAction;
